import React from 'react';
import { withTheme } from 'styled-components';
import { Helmet } from 'react-helmet';

export default withTheme(({ theme, children }) => (
  <>
    <Helmet key="helmet">
      <link rel="shortcut icon" href={theme.brand.favicon} />
      <title>Collections</title>
    </Helmet>
    {children}
  </>
));
